/**
 * Modal wrapper qui réutilise EXACTEMENT le LoadingNoteWizard de la page publique
 * (5 étapes, photos GPS, multiples signatures), pour les contextes admin/transfert.
 *
 * PM Spec 05/05/2026 — alignement UX admin ↔ portail externe.
 *
 * Props :
 *  - open, onOpenChange
 *  - operation: object (opération spot OU contract_run)
 *  - type: "loading" | "unloading"
 *  - entityKind: "operation" | "transfer"
 *  - onSuccess
 */
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import LoadingNoteWizard from './LoadingNoteWizard';

const token = 'cookie-auth';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LoadingNoteWizardModal = ({
  open, onOpenChange, operation, type, entityKind = 'operation', onSuccess,
}) => {
  if (!operation || !type) return null;

  const prefix = entityKind === 'transfer' ? 'transfers' : 'operations';
  const endpointPrefix = `${API}/${prefix}/${operation.id}/loading-notes`;
  const authHeaders = token ? { Authorization: 'Bearer cookie-auth' } : {};

  // Récupération du nom opérateur connecté pour pré-remplissage signatures
  const operatorName =
    operation?.assignedFieldOpsName ||
    operation?.assignedOperatorName ||
    '';

  const title = type === 'loading'
    ? 'Bon de chargement'
    : 'Bon de déchargement';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl max-h-[95vh] overflow-y-auto p-0">
        <DialogHeader className="px-6 pt-6 pb-2">
          <DialogTitle className="text-xl">{title}</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">
          <LoadingNoteWizard
            type={type}
            operation={operation}
            operatorName={operatorName}
            endpointPrefix={endpointPrefix}
            authHeaders={authHeaders}
            onCompleted={() => {
              onSuccess?.();
              onOpenChange?.(false);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingNoteWizardModal;
